import React, { Dispatch, SetStateAction, useState } from "react";
import { Modal, Button, Loading } from "@alm/flow-ds/components";
import { useTranslation } from "react-i18next";

type Props = {
	deleteElement: () => void | Promise<void>;
	name: string;
	type: "definition" | "element";
	isOpen: boolean;
	setIsOpen: Dispatch<SetStateAction<boolean>>;
};

export default function DeleteDialog({
	name,
	deleteElement,
	type,
	isOpen,
	setIsOpen,
}: Props) {
	const { t } = useTranslation();
	const [deleteLoading, setDeleteLoading] = useState(false);
	return isOpen ? (
		<Modal
			className="delete-dialog"
			close={() => setIsOpen(false)}
			isOpen={isOpen}
			title={t("formDesigner.dialogs.deleteTitle", {
				name,
				type: t(`formDesigner.types.${type}`),
			})}
			modalSize="sm"
			showHeaderClose={false}>
			<Button
				label={t("common.labels.cancel")}
				className="btn-default"
				onClick={() => setIsOpen(false)}
			/>
			<Button
				label={!deleteLoading && t("common.labels.delete")}
				className="btn-danger delete-dialog-btn"
				onClick={async () => {
					if (type === "definition") setDeleteLoading(true);
					await deleteElement();
					if (type === "definition") setDeleteLoading(false);
					setIsOpen(false);
				}}>
				{deleteLoading && <Loading />}
			</Button>
		</Modal>
	) : null;
}
